import { render, staticRenderFns } from "./report.vue?vue&type=template&id=2d4352b6&scoped=true"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"
import style0 from "./report.vue?vue&type=style&index=0&id=2d4352b6&lang=scss"
import style1 from "./report.vue?vue&type=style&index=1&id=2d4352b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4352b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4352b6')) {
      api.createRecord('2d4352b6', component.options)
    } else {
      api.reload('2d4352b6', component.options)
    }
    module.hot.accept("./report.vue?vue&type=template&id=2d4352b6&scoped=true", function () {
      api.rerender('2d4352b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/report.vue"
export default component.exports